// What the app shows before the signed-in user resolves, or when startup fails.
//
// While loading, this is the boot loader from index.html, rendered again:
// React emptied #app when it mounted, which removed the ring the page had
// been showing since before the bundle loaded, and the stylesheet that
// draws it is still in the document head. Re-rendering the same element
// keeps one loader on screen from the first paint to the dashboard.
// `data-mounted` skips the loader's fade-in delay, because the ring is
// already visible when this renders.
//
// On a startup failure the ring gives way to the reason and a reload
// control, in the dashboard's own control language.
export default function StartupScreen({ error = null }) {
    if (!error) {
        return (
            <div id="boot-loader" data-mounted="" role="status" aria-label="Loading">
                <span />
            </div>
        );
    }
    return (
        <main role="alert" className="grid min-h-screen place-items-center bg-[color:var(--bg)] p-[24px] text-[color:var(--ink)]">
            <div className="max-w-[420px] text-center">
                <div className="text-[10px] uppercase tracking-[0.14em] text-[color:var(--muted-soft)]">Unable to load the dashboard</div>
                <p className="mt-[6px] text-[12px] leading-[1.5] text-[color:var(--muted)]">
                    The service could not complete startup. Reload to try again. If this continues, contact your administrator.
                </p>
                <button
                    type="button"
                    onClick={() => window.location.reload()}
                    className="mt-[12px] cursor-pointer rounded-[2px] border border-[color:var(--line)] px-[8px] py-[3px] text-[10px] uppercase tracking-[0.14em] text-[color:var(--muted-soft)] hover:border-[color:var(--ink)] hover:text-[color:var(--ink)] focus-visible:outline-2 focus-visible:outline-offset-2"
                >
                    Reload dashboard
                </button>
            </div>
        </main>
    );
}
